(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-main"]) return;
  try {
    
(function() {
  var select = document.getElementById('sort-by');
  if (select) {
    select.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  var grid = document.querySelector('[data-collection-grid]');
  var trigger = document.querySelector('[data-collection-load-more]');
  if (!grid || !trigger) return;

  var loading = false;

  function loadNext() {
    if (loading) return;
    var nextUrl = trigger.getAttribute('data-next-url');
    if (!nextUrl) return;
    loading = true;

    var link    = trigger.querySelector('[data-load-more-link]');
    var spinner = trigger.querySelector('[data-load-more-spinner]');
    if (link) link.hidden = true;
    if (spinner) spinner.hidden = false;

    var sectionId = trigger.getAttribute('data-section-id');
    var sep = nextUrl.indexOf('?') > -1 ? '&' : '?';

    fetch(nextUrl + sep + 'section_id=' + sectionId)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-collection-grid]');
        if (newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function(card) {
            grid.appendChild(card);
          });
        }

        var newTrigger = doc.querySelector('[data-collection-load-more]');
        var newNextUrl = newTrigger ? newTrigger.getAttribute('data-next-url') : null;
        if (newNextUrl) {
          trigger.setAttribute('data-next-url', newNextUrl);
        } else {
          observer.disconnect();
          trigger.remove();
        }
      })
      .catch(function() {
        if (link) window.location.href = link.href;
      })
      .finally(function() {
        loading = false;
        if (link) link.hidden = false;
        if (spinner) spinner.hidden = true;
      });
  }

  trigger.addEventListener('click', function(e) {
    var link = e.target.closest('[data-load-more-link]');
    if (!link) return;
    e.preventDefault();
    loadNext();
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) loadNext();
    });
  }, { rootMargin: '800px 0px' });

  observer.observe(trigger);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.coll-slider');
  if (!section) return;

  var track = section.querySelector('.coll-slider__track');
  var dotsContainer = section.querySelector('.coll-slider__dots');
  var prevBtn = section.querySelector('.coll-slider__arrow--prev');
  var nextBtn = section.querySelector('.coll-slider__arrow--next');
  var items = track ? Array.from(track.querySelectorAll('.coll-slider__item')) : [];

  if (!track || items.length < 2) return;

  var isTouchDevice = window.matchMedia('(hover: none)').matches;
  if (!isTouchDevice && prevBtn && nextBtn) {
    prevBtn.removeAttribute('hidden');
    nextBtn.removeAttribute('hidden');
  }

  var dots = [];
  if (dotsContainer) {
    items.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'coll-slider__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function() { scrollToItem(i); });
      dotsContainer.appendChild(dot);
      dots.push(dot);
    });
  }

  function scrollToItem(index) {
    var item = items[index];
    if (!item) return;
    track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function getActiveIndex() {
    var trackLeft = track.getBoundingClientRect().left;
    var closest = 0, minDist = Infinity;
    items.forEach(function(item, i) {
      var dist = Math.abs(item.getBoundingClientRect().left - trackLeft);
      if (dist < minDist) { minDist = dist; closest = i; }
    });
    return closest;
  }

  function updateDots() {
    var active = getActiveIndex();
    dots.forEach(function(dot, i) { dot.classList.toggle('is-active', i === active); });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function() { scrollToItem(Math.max(0, getActiveIndex() - 1)); });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function() { scrollToItem(Math.min(items.length - 1, getActiveIndex() + 1)); });
  }

  var scrollTimer;
  track.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(updateDots, 80);
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-catch-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.catch-slider');
  if (!section) return;

  var track = section.querySelector('.catch-slider__track');
  var dotsContainer = section.querySelector('.catch-slider__dots');
  var prevBtn = section.querySelector('.catch-slider__arrow--prev');
  var nextBtn = section.querySelector('.catch-slider__arrow--next');
  var items = track ? Array.from(track.querySelectorAll('.catch-slider__item')) : [];

  if (!track || items.length < 2) return;

  var isTouchDevice = window.matchMedia('(hover: none)').matches;
  if (!isTouchDevice && prevBtn && nextBtn) {
    prevBtn.removeAttribute('hidden');
    nextBtn.removeAttribute('hidden');
  }

  var dots = [];
  if (dotsContainer) {
    items.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'catch-slider__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function() { scrollToItem(i); });
      dotsContainer.appendChild(dot);
      dots.push(dot);
    });
  }

  function scrollToItem(index) {
    var item = items[index];
    if (!item) return;
    track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function getActiveIndex() {
    var trackLeft = track.getBoundingClientRect().left;
    var closest = 0, minDist = Infinity;
    items.forEach(function(item, i) {
      var dist = Math.abs(item.getBoundingClientRect().left - trackLeft);
      if (dist < minDist) { minDist = dist; closest = i; }
    });
    return closest;
  }

  function updateDots() {
    var active = getActiveIndex();
    dots.forEach(function(dot, i) { dot.classList.toggle('is-active', i === active); });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function() { scrollToItem(Math.max(0, getActiveIndex() - 1)); });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function() { scrollToItem(Math.min(items.length - 1, getActiveIndex() + 1)); });
  }

  var scrollTimer;
  track.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(updateDots, 80);
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  var header = document.querySelector('.site-header');
  var hamburger = document.querySelector('.site-header__hamburger');
  var mobileNav = document.getElementById('mobile-nav');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function() {
      var isOpen = !mobileNav.hidden;
      mobileNav.hidden = isOpen;
      hamburger.setAttribute('aria-expanded', String(!isOpen));
    });

    document.addEventListener('click', function(e) {
      if (header && !header.contains(e.target)) {
        mobileNav.hidden = true;
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !mobileNav.hidden) {
        mobileNav.hidden = true;
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.focus();
      }
    });
  }

  var mobileToggle = document.querySelector('.site-header__mobile-toggle');
  var mobileSubmenu = document.getElementById('mobile-shop-fish-submenu');
  if (mobileToggle && mobileSubmenu) {
    mobileToggle.addEventListener('click', function() {
      var isOpen = !mobileSubmenu.hidden;
      mobileSubmenu.hidden = isOpen;
      mobileToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  if (header && header.classList.contains('site-header--sticky')) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 80) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
